import type * as React from 'react';
import { get } from '@Domain/Api';
import aboutCandidatesFetched, {
	type AboutCandidatePayload,
	type AboutCandidatesFetchedAction,
} from '@Application/Subjects/Actions/aboutCandidatesFetched';
import aboutCandidatesFetchFailed, {
	type AboutCandidatesFetchFailedAction,
} from '@Application/Subjects/Actions/aboutCandidatesFetchFailed';
import type FetchAboutCandidates from '@Application/Subjects/Queries/FetchAboutCandidates';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AboutCandidatesFetchedAction | AboutCandidatesFetchFailedAction;

export default (query: FetchAboutCandidates) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const candidates = await get<AboutCandidatePayload[]>(
				`${parameters.api.host}/api/facilities/${query.facilityId}/subject-types/${query.typeId}/about-candidates?${query.toQueryString()}`,
			);

			const action = aboutCandidatesFetched(query.search, candidates);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aboutCandidatesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
